module.exports = __webpack_public_path__ + "static/media/ptsb.3d3e72c1.png";